import { Mixins, Component, Watch } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

@Component({
    inheritAttrs: false,
})
export default class SelectGroupProject extends Mixins<MixinInterface>() {
    beforeMount() {
        if (!this.currentProjectId) {
            if (this.$route.params.projectId) {
                this.currentProjectId = this.$route.params.projectId
            } else {
                this.currentProjectId = this.allProjects[0] ? this.allProjects[0].id : null
            }
        }
    }
}
